import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cns from 'classnames';
import Image from './Image';
import { generateNumberFromString } from '../utils/NumberUtils';

const getSrc = (user) => {
    const { image } = user;
    if (image) {
        return image;
    }
    return null;
};

const getAvatarColor = (profile) => generateNumberFromString(profile._id, 12) + 1;

const sizeConfig = {
    default: 128,
    thumbnail: 36,
    small: 64,
    medium: 128,
    large: 256
};

const fontSizeConfig = {
    default: 58,
    thumbnail: 16,
    small: 28,
    medium: 58,
    large: 120
};

const LinkElement = (props) => {
    const { children, user, includeLink, className } = props;
    if (includeLink) {
        return (
            <span to={`/profile/${user._id}`} title={`${user.firstName} ${user.lastName}`} className={className}>
                {children}
            </span>
        );
    }
    return <span className={className}>{children}</span>;
};

LinkElement.propTypes = {
    children: PropTypes.object.isRequired,
    includeLink: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    className: PropTypes.string
};

const createDefaultAvatar = (userProfile, dimension, fontSize, includeLink, className) => {
    const { firstName, lastName, email = '' } = userProfile;
    let colorCode = 1;
    if (userProfile._id) {
        colorCode = getAvatarColor(userProfile);
    }

    let characters;
    if (firstName) {
        characters = lastName ? `${firstName[0]}${lastName[0]}` : firstName.slice(0, 2);
    } else if (lastName) {
        characters = lastName.slice(0, 2);
    } else {
        characters = email.slice(0, 2);
    }

    return (
        <LinkElement user={userProfile} includeLink={includeLink} className={className}>
            <div
                className={cns('user-avatar', 'default-user-avatar', `avatar-color-${colorCode}`)}
                style={{ height: dimension, width: dimension }}
            >
                <span style={{ fontSize: `${fontSize}px` }}>{characters.toUpperCase()}</span>
            </div>
        </LinkElement>
    );
};

class UserAvatar extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        size: PropTypes.string,
        dimension: PropTypes.number,
        includeLink: PropTypes.bool,
        circle: PropTypes.bool,
        className: PropTypes.string,
        radius: PropTypes.string,
        avatarFontSize: PropTypes.number
    };

    render() {
        const {
            className,
            includeLink = true,
            user = {},
            size = 'default',
            circle = true,
            dimension: customDimension = null,
            avatarFontSize = null,
            radius = 'max'
        } = this.props;

        const dimension = customDimension || sizeConfig[size];
        const imageShapeClass = circle === false ? '' : 'img-circle';
        const src = getSrc(user, dimension);
        let bannerOverlay;
        if (user.rewardBanner) {
            bannerOverlay = { overlayId: user.rewardBanner, dimension: { w: dimension * 2, h: dimension * 2 } };
        }
        if (src) {
            return (
                <Fragment>
                    <LinkElement
                        className={cns(className, 'user-avatar', 'userAvatar')}
                        user={user}
                        includeLink={includeLink}
                    >
                        <Image
                            style={{ width: dimension, height: dimension }}
                            src={src}
                            dimension={{ h: dimension * 2, w: dimension * 2 }}
                            className={imageShapeClass}
                            alt={`User Avatar for ${user.firstName} ${user.lastName}`}
                            overlay={bannerOverlay}
                            radius={radius}
                        />
                    </LinkElement>
                </Fragment>
            );
        }

        const fontSize = avatarFontSize || fontSizeConfig[size];

        return createDefaultAvatar(user, dimension, fontSize, includeLink, className);
    }
}

export default UserAvatar;
